import { useMutation } from '@apollo/react-hooks';
import { kmsClient } from 'api';
import { TRIGGER_AUDIENCE_GROOMING_MUTATION } from './triggerAudienceGrooming.mutation';
import {
  TriggerAudienceGroomingMutation,
  TriggerAudienceGroomingMutationVariables,
  TriggerAudienceGroomingMutation_triggerAudienceGrooming_grooming
} from './__generated__/TriggerAudienceGroomingMutation';

interface Props {
  onCompleted: (grooming: TriggerAudienceGroomingMutation_triggerAudienceGrooming_grooming) => void;
  onError: (errors: string[]) => void;
}

export function useTriggerAudienceGrooming({
  onCompleted,
  onError
}: Props): [(variables: TriggerAudienceGroomingMutationVariables) => void, { loading: boolean }] {
  const [triggerAudienceGrooming, { loading }] = useMutation<
    TriggerAudienceGroomingMutation,
    TriggerAudienceGroomingMutationVariables
  >(TRIGGER_AUDIENCE_GROOMING_MUTATION, {
    client: kmsClient,
    onCompleted: (data) => {
      if (data.triggerAudienceGrooming?.errors?.length) {
        onError(data.triggerAudienceGrooming.errors);
      } else {
        onCompleted(data.triggerAudienceGrooming!.grooming!);
      }
    },
    onError: (error) => onError([error.message])
  });

  return [(variables) => triggerAudienceGrooming({ variables }), { loading }];
}
